import { type TaskAgentRunResponse } from "@/src/app/api/tasks/[taskId]/agent-run/route";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getTaskAgentRun(taskId: string): Promise<TaskAgentRunResponse> {
  return fetchJSON(`/api/tasks/${taskId}/agent-run`);
}
